<template>
  <div class="info-wrapper">
    <img class="info-wrapper" :src="textData.img">
    <div ref="move" :class="moveClass">
      <div class="big-data_p">
        <h2>{{textData.title}}</h2>
        <p class="fnt_24 title">{{textData.describe1}}</p>
        <div class="down">
          <p class="fnt_24">{{textData.describe2}}</p>
          <p class="fnt_24">{{textData.describe3}}</p>
          <el-button @click="routerTo(textData.route)">
            了解更多内容
            <i class="el-icon-caret-right el-icon--right"></i>
          </el-button>
        </div>
      </div>
      <div class="big-data_r">
        <div class="child-item" v-for="(item, index) in dataList" :key="index">
          <img :src="item.img"/>
          <p class="fnt_24">{{item.content}}</p>
        </div>
<!--        <div class="child-item">-->
<!--          <img src="../../../static/images/firstPage/bigDataService.png"/>-->
<!--          <p class="fnt_24">建立企业统一访问入口，提供一致化的用户体验服务于客户，方便于用户</p>-->
<!--        </div>-->
<!--        <div class="child-item">-->
<!--          <img src="../../../static/images/firstPage/serviceCustomer.png"/>-->
<!--          <p class="fnt_24">建立企业统一访问入口，提供一致化的用户体验服务于客户，方便于用户</p>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      moveClass: 'big-data-text move-before',
      textData: {},
      dataList: []
    }
  },
  methods: {
    routerTo (route) {
      this.$router.push({
        path: route,
        query: ''
      })
    }
  },
  mounted: function () {
    // console.log('this.$boss', this.$boss)
    if (this.$boss) {
      this.textData = this.$boss.page21.g21[0]
      this.dataList = this.$boss.page22.g22.reverse()
    }
  }
}
</script>
<style scoped lang="less">
@media screen and (max-width: 1900px) {
  .info-wrapper {
    width: 100%;
    height: 100%;
    /*background: url("../../../static/images/firstPage/bigDataService.png") no-repeat;*/
    /*background-size: 100% 100%;*/
  }
  .data-text {
    color: #fff;
    position: absolute;
    left: 200px;
    top: 25%;
    text-align: left;
    width: 100%;
    z-index: 999;
    transition: all 1.5s;
    -webkit-transition: all 1.5s;
  }
  .move-before{
    transform: translate(0,-50%);
    -webkit-transform: translate(0,-50%);
    -ms-transform: translate(0,-50%);
    opacity: 0;

  }

  .move-after{
    transform: translate(-100px,-50%);
    -webkit-transform: translate(-100px,-50%);
    -ms-transform: translate(-100px,-50%);
    opacity: 1;
  }

  .big-data_p {
    flex: 1;
    .title{
      width: 35%;
    }
  }
  .big-data_p h2, .big-data_p p {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .big-data_p p {
    font-size: 24px;
  }
  .big-data_p h2 {
    width: 100%;
    font-size: 36px;
    margin-bottom: 15px;
    line-height: 60px;
    max-height: 120px;
  }
  .down {
    position: fixed;
    /*bottom: 10%;*/
    margin-top: 5%;
    .el-button {
      color: #fa6e1a;
      background-color: transparent;
      border: 1px solid #fa6e1a;
      font-size: 18px;
    }
  }
  .big-data_r {
    width: 50%;
    position: absolute;
    top: 15%;
    right: 150px;
    display: flex;
    justify-content: space-between;
    .child-item{
      /*float: left;*/
      /*margin-left: 20px;*/
      width: 32%;
      /*height: 80%;*/
      background-color: rgba(255, 255, 255, 0.85);
      /*border: 1px solid #13ce66;*/
      img {
        width: calc(100% - 32px);
        height: 230px;
        padding: 16px 16px;
      }
      img:hover {
        transform: scale(1.1);
      }
      .fnt_24{
        font-size: 20px;
        color: #6d6d6d;
        padding: 16px;
        line-height: 28px;
        /*font-family: "黑体", Helvetica, Arial, sans-serif;*/
      }
    }
  }
}
@media screen and (min-width: 1901px) {
  .info-wrapper {
    width: 100%;
    height: 100%;
    /*background: url("../../../static/images/firstPage/bigDataService.png") no-repeat;*/
    /*background-size: 100% 100%;*/
  }
  .data-text {
    color: #fff;
    position: absolute;
    left: 200px;
    top: 25%;
    text-align: left;
    width: 100%;
    z-index: 999;
    transition: all 1.5s;
    -webkit-transition: all 1.5s;
  }
  .move-before{
    transform: translate(0,-50%);
    -webkit-transform: translate(0,-50%);
    -ms-transform: translate(0,-50%);
    opacity: 0;

  }

  .move-after{
    transform: translate(-100px,-50%);
    -webkit-transform: translate(-100px,-50%);
    -ms-transform: translate(-100px,-50%);
    opacity: 1;
  }

  .big-data_p {
    flex: 1;
    .title{
      width: 35%;
    }
  }
  .big-data_p h2, .big-data_p p {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .big-data_p p {
    font-size: 24px;
  }
  .big-data_p h2 {
    font-size: 48px;
    margin-bottom: 15px;
    line-height: 60px;
    max-height: 120px;
  }
  .down {
    position: fixed;
    /*bottom: 10%;*/
    margin-top: 10%;
    .el-button {
      color: #fa6e1a;
      background-color: transparent;
      border: 1px solid #fa6e1a;
      font-size: 18px;
    }
  }
  .big-data_r {
    position: absolute;
    top: 15%;
    right: 215px;
    .child-item{
      float: left;
      margin-left: 20px;
      width: 322px;
      height: 570px;
      background-color: rgba(255, 255, 255, 0.85);
      /*border: 1px solid #13ce66;*/
      img {
        width: 290px;
        height: 312px;
        padding: 16px 16px;
      }
      img:hover {
        transform: scale(1.1);
      }
      .fnt_24{
        font-size: 24px;
        color: #6d6d6d;
        padding: 16px;
        line-height: 36px;
        font-family: "黑体", Helvetica, Arial, sans-serif;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/bigDataService.vue